<template>
  <div>
    <el-dialog :title="$t('system.add_role')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" class="diglog-card" width="900px" @close="initData">
      <el-form ref="form" :model="form" label-width="150px" :rules="rules" label-position="left">
        <div class="assign-role-container">
          <div class="assign-role-container-left">
            <div class="section-title">{{ $t('system.authority') }}</div>
            <div class="section-tip">{{ $t('tips.following_permission_granted_role') }}</div>
            <SystemMchMenu
              :menu-list="menuList"
              :auth-list="form.role_auths"
              :modal-flag="1"
            />
          </div>
          <div class="assign-role-container-right">
            <div class="section-title">{{ $t('system.role_details') }}</div>
            <div class="section-tip">{{ $t('tips.manage_details_new_role') }}</div>
            <el-form-item :label="$t('system.role_name')" prop="role_name" required>
              <el-input v-model="form.role_name" size="small" placeholder="Enter Role Name" autocomplete="off" clearable />
            </el-form-item>
            <el-form-item :label="$t('system.remark')" prop="remark">
              <el-input v-model="form.remark" size="small" placeholder="Enter your message here" class="search-frame" autocomplete="off" clearable />
            </el-form-item>

            <div slot="footer" class="dialog-footer-fixed">
              <el-button type="primary" plain class="btn-diglog-control" @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
              <el-button class="btn-diglog-control" type="primary" :disabled="listLoading" @click="submitAddRole('form')">{{ $t('components.submit') }}</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { addMerchantRole } from '@/api/system/system'
export default {
  name: 'AddRoleModal',
  components: {
    SystemMchMenu: () => import('../System/SystemBaseMenu')
  },
  props: {
    menuList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialogUserVisible: false,
      listLoading: false,
      form: {
        role_name: '',
        remark: '',
        role_auths: []
      },
      // cities: cityOptions,
      rules: {},
      isIndeterminate: true,
      checkAll: false
    }
  },
  mounted() {
    this.$bus.off('UPDATE_CHECK_AUTH_ADD_MODAL')
    this.$bus.on('UPDATE_CHECK_AUTH_ADD_MODAL', (value) => {
      this.form.role_auths = JSON.parse(JSON.stringify(value))
    })
  },
  methods: {
    changeModalStatus(status) {
      this.dialogUserVisible = status
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    initData() {
      this.form = {
        role_name: '',
        remark: '',
        role_auths: []
      }
    },
    submitAddRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.listLoading = true
            const params = {
              role_name: this.form.role_name,
              remark: this.form.remark,
              auth_codes: this.form.role_auths
            }
            addMerchantRole(params).then(res => {
              this.$message.success('Success')
              this.$emit('updateRoleList')
              this.dialogUserVisible = false
            }).finally(() => {
              this.listLoading = false
            })
          })
        }
      })
    },
    handleCheckAllChange() {

    },
    handleCheckedChange() {

    }
  }
}
</script>

<style scoped>
.assign-role-container{
  width: 100%;
  display: flex;
}
.assign-role-container-left{
  position: relative;
  margin: -24px;
  padding: 24px;
  width: 350px;
  margin-right: 24px;
  background: rgba(72, 140, 232, 0.10);

}
.assign-role-container-right{
  flex: 1;
  position: relative;
}
.role-name-item{
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.role-name-item-text{
  color: #364250;
  font-size: 14px;
  font-weight: bold;
}

.dialog-footer-fixed{
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
